import LegacyInteractionForm from './legacy-interaction-form';
import DynamicInteractionForm from '../../form/interaction-form';
import { useFeatureFlag } from 'entities/helpers/use-feature-flag';

const InteractionForm = (props) => {
  // NOTE: LaunchDarkly Flags DO NOT WORK if this component is a child of the OLD Modal component (i.e. the one inside "src/scripts/components/modal")
  // This is because the old modals are rendered inside of the "MetaContext" and, therefore, are not descendents of our LaunchDarklyProvider.
  // The "DynamicInteractionForm" stores all of these LD values inside a context (InteractionFormContext). The LegacyInteractionForm needs them as props.
  const { flagEnabled: hasDxo } = useFeatureFlag('dxo');
  const { flagEnabled: hasConditionalFields } = useFeatureFlag('conditionalFields');
  const { flagEnabled: enableInteractionSolicitorType } = useFeatureFlag('enableInteractionSolicitorType');
  const { flagEnabled: interactionDescriptionRichTextEditor } = useFeatureFlag('interactionDescriptionRichTextEditor');

  if (hasConditionalFields) {
    return <DynamicInteractionForm {...props} />;
  } else {
    return (
      <LegacyInteractionForm
        {...props}
        hasDxo={hasDxo}
        enableInteractionSolicitorType={enableInteractionSolicitorType}
        interactionDescriptionRichTextEditor={interactionDescriptionRichTextEditor}
      />
    );
  }
};

export default InteractionForm;
